<template>
  <div class="bonusProduct">
    <div class="card-header">
      <p>
        <i class="el-icon-present"></i>换新福利
        <span>环保补助金{{product.bonus_price}}元</span>
      </p>
      <i class="el-icon-circle-check checkBonus"></i>
    </div>
  </div>
</template>

<script>
export default {
  props:["product"],
  data() {
    return {
      active: 2,
      ordersn: {},
      checked: true
    };
  },
};
</script>

<style scoped>
.bonusProduct{margin:10px 0 0 0;background: #fff;padding:20px 20px;box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);font-size: 16px;position: relative;}
.bonusProduct span{color:#e60012}
.checkBonus{position: absolute;right:20px;top:20px;font-size: 24px;}
.bonusProduct .el-icon-present{font-size: 20px;color: #f00;margin-right: 5px;}
</style>
